/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { GroupsControllerUpdateGroupRanksMutationRequest, GroupsControllerUpdateGroupRanksMutationResponse, GroupsControllerUpdateGroupRanksPathParams, GroupsControllerUpdateGroupRanks400, GroupsControllerUpdateGroupRanks401, GroupsControllerUpdateGroupRanks403, GroupsControllerUpdateGroupRanks404 } from "../../models/documentGroupsController/GroupsControllerUpdateGroupRanks";

function getGroupsControllerUpdateGroupRanksUrl(groupId: GroupsControllerUpdateGroupRanksPathParams["groupId"]) {
  const res = { method: 'PATCH', url: `/api/v1/documents/groups/${groupId}/ranks` as const }  
  return res
}

/**
 * @description Pins the rank of every listed member in one write (lower governs; ties allowed; null = unranked). Members not listed keep their rank. Listed INFERRED members become USER_VERIFIED so recompute never moves them. Rejected on CONTRACT_SET and DISCREPANCY_SET. When the ranks change the project's effective orders, relationship re-inference is notified.
 * @summary Set member ranks on an ORDER_OF_PRECEDENCE group
 * {@link /api/v1/documents/groups/:groupId/ranks}
 */
export async function groupsControllerUpdateGroupRanks(groupId: GroupsControllerUpdateGroupRanksPathParams["groupId"], data?: GroupsControllerUpdateGroupRanksMutationRequest, config: Partial<RequestConfig<GroupsControllerUpdateGroupRanksMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<GroupsControllerUpdateGroupRanksMutationResponse, ResponseErrorConfig<GroupsControllerUpdateGroupRanks400 | GroupsControllerUpdateGroupRanks401 | GroupsControllerUpdateGroupRanks403 | GroupsControllerUpdateGroupRanks404>, GroupsControllerUpdateGroupRanksMutationRequest>({ method : "PATCH", url : getGroupsControllerUpdateGroupRanksUrl(groupId).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}